// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"c68f334f","22":"c68f334f","24":"c68f334f","162":"c68f334f","444":"c68f334f","686":"c68f334f","777":"c68f334f","790":"c68f334f","930":"c68f334f"}[chunkId] + ".chunk.css";
};